import { render, staticRenderFns } from "./proofCategory.vue?vue&type=template&id=86e2a332"
import script from "./proofCategory.vue?vue&type=script&lang=js"
export * from "./proofCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports